import { render, staticRenderFns } from "./QFormSmsCorrespondence.vue?vue&type=template&id=9f7de6b4&"
import script from "./QFormSmsCorrespondence.vue?vue&type=script&lang=js&"
export * from "./QFormSmsCorrespondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports